import React, { useEffect } from 'react';

import './CategoryDescription.scss';
import { convert } from '../../helpers/date';
import IconsBar from '../IconsBar/IconsBar.jsx';
import parseContentHTML from '../../helpers/parseContentHTML';
import CalculationTool from '../CalculationTool/CalculationTool.jsx';
import PregnancyCalendar from '../PregnancyCalendar/PregnancyCalendar.jsx';

export default function CategoryDescription(props) {
  const uri = props.contentUri.toLowerCase();

  const contentBlocks = parseContentHTML(props.contentHTML);

  const postedDate = convert(props.postedAt.replace(/-/g, '/'), props.locale);

  useEffect(() => {
    if (window && window.iFrameResize)
      window.iFrameResize({ log: false }, '#formframe');
  }, []);

  return (
    <article id="categoryDescription">
      <div id="categoryDescription_header">
        <h2 className="categoryDescription_desktop">{props.title}</h2>

        <span id="categoryDescription_posted_date">{postedDate}</span>

        <IconsBar {...props} />
      </div>

      <div className="categoryDescription_embedded_top_tool">
        {topComponent(uri)}
      </div>

      <div id="categoryDescription_content">
        {props.intro && (
          <p
            className="categoryDescription_text"
            id="categoryDescription_text_intro"
          >
            {props.intro}
          </p>
        )}

        {contentBlocks.map((block, idx) => {
          if (block.html)
            return (
              <div
                className="categoryDescription_text"
                key={idx}
                dangerouslySetInnerHTML={{ __html: block.html }}
              />
            );

          if (!block.component) return null;

          const Component = block.component;

          return (
            <Component
              key={idx}
              {...props}
              {...block.args}
              imageUrl={block.args.imageUrl}
              username={props.user.username}
              loginUrl={props.config.LOGIN_URL}
            />
          );
        })}
      </div>

      <div className="categoryDescription_embedded_bottom_tool">
        {bottomComponent(uri)}
      </div>
    </article>
  );

  function topComponent(uri) {
    switch (uri) {
      case 'vruchtbare-dagen-berekenen':
        return (
          <CalculationTool type="fertility" loginUrl={props.config.LOGIN_URL} />
        );

      case 'uitgerekende-datum':
        return (
          <CalculationTool
            type="dueDate"
            username={props.user.username}
            initialDate={props.query.date}
            loginUrl={props.config.LOGIN_URL}
            changeUserData={props.changeUserData}
          />
        );
    }
  }

  function bottomComponent(uri) {
    switch (uri) {
      case 'zwangerschapskalender':
        return <PregnancyCalendar {...props} />;

      case 'babykalender':
        return <PregnancyCalendar {...props} type="baby" />;
    }
  }
}
